import { useAuth } from './useAuth';

/**
 * True when the signed-in user is a district manager / supervisor (server-side
 * gate surfaced on the auth response, #2475). Reads the cached flag — no extra
 * request — so it's safe to call from nav on every render.
 */
export function useIsManager(): boolean {
  const { user } = useAuth();
  return !!user?.is_manager;
}
